/* ============================================================
   Lululi Kids: experiências v2 (celular primeiro)

   1) Índice UV ao vivo (Open-Meteo, sem chave). Cidade de praia ou
      "minha localização" (só ao toque). Cache de 1 h. Se a API falhar,
      fica só "Sol forte? Blusa de proteção."
   2) Dia de praia: céu do amanhecer ao pôr do sol conforme a rolagem
      (CSS scroll-driven; aqui só o reserva em JS) e pontos tocáveis.

   As contas puras ficam no topo e são testadas em
   scripts/teste-experiencias.js (node).
   ============================================================ */
(function () {
  // ---------- contas puras ----------
  function limitar(v, a, b) { return Math.min(b, Math.max(a, v)); }

  // escala oficial do índice UV (OMS/INPE): valor arredondado
  var NIVEIS = [
    { max: 2, nivel: 'baixo', rotulo: 'Baixo', frase: 'Sol fraco hoje. Mesmo assim, leve a blusa pra praia.' },
    { max: 5, nivel: 'moderado', rotulo: 'Moderado', frase: 'Sol de respeito. Blusa e sombra no meio do dia.' },
    { max: 7, nivel: 'alto', rotulo: 'Alto', frase: 'Sol alto. Blusa de proteção e sombra das 10h às 16h.' },
    { max: 10, nivel: 'muito-alto', rotulo: 'Muito alto', frase: 'Sol muito forte. Blusa de proteção e sombra das 10h às 16h.' },
    { max: Infinity, nivel: 'extremo', rotulo: 'Extremo', frase: 'Sol extremo. Fuja do sol do meio-dia e vá de blusa de proteção.' },
  ];
  var FRASE_FALHA = 'Sol forte? Blusa de proteção.';
  function classificarUV(v) {
    if (v == null || v === '' || typeof v === 'boolean') return null;
    v = +v;
    if (!isFinite(v) || v < 0) return null;
    var n = Math.round(v);
    for (var i = 0; i < NIVEIS.length; i++) {
      if (n <= NIVEIS[i].max) return { indice: n, nivel: NIVEIS[i].nivel, rotulo: NIVEIS[i].rotulo, frase: NIVEIS[i].frase };
    }
    return null;
  }

  var CIDADES = [
    ['Salvador', -12.97, -38.5], ['Porto Seguro', -16.45, -39.06], ['Ilhéus', -14.79, -39.05],
    ['Rio de Janeiro', -22.91, -43.17], ['Vitória', -20.32, -40.34], ['Guarapari', -20.67, -40.5],
    ['Florianópolis', -27.6, -48.55], ['Recife', -8.05, -34.88], ['Fortaleza', -3.73, -38.53],
    ['Maceió', -9.67, -35.74], ['Natal', -5.79, -35.21], ['Santos', -23.96, -46.33],
  ].map(function (c) { return { nome: c[0], lat: c[1], lon: c[2] }; });
  var MINHA = 'Minha localização';

  var HORA = 3600000;
  function chaveLocal(lat, lon) { return (+lat).toFixed(2) + ',' + (+lon).toFixed(2); }
  function hojeSP(agora) { return new Date(agora).toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' }); }
  // vale por 1 h e só no mesmo dia (o máximo é "de hoje")
  function cacheValido(e, agora) {
    return !!e && typeof e.v === 'number' && agora - e.t >= 0 && agora - e.t < HORA && e.dia === hojeSP(agora);
  }
  // escolha guardada: cidade da lista ou "minha localização" com coordenadas
  function escolhaValida(e) {
    if (!e) return CIDADES[0];
    var c = CIDADES.filter(function (x) { return x.nome === e.nome; })[0];
    if (c) return c;
    if (e.nome === MINHA && isFinite(e.lat) && isFinite(e.lon) && Math.abs(e.lat) <= 90 && Math.abs(e.lon) <= 180) {
      return { nome: MINHA, lat: +e.lat, lon: +e.lon };
    }
    return CIDADES[0];
  }

  // céu do dia de praia: amanhecer (0), manhã, meio-dia (.5), tarde, pôr do sol (1)
  // as mesmas cores estão nos @keyframes lululi-ceu do lululi.css
  var CEU = [
    { p: 0, topo: '#ffb38a', base: '#ffe7c7', mar: '#4fb8c4', sol: '#ffd08a', x: 150, y: 226 },
    { p: 0.25, topo: '#8fd3f4', base: '#e3f6ff', mar: '#1fb5b5', sol: '#ffe07a', x: 200, y: 120 },
    { p: 0.5, topo: '#4fc3ee', base: '#c9efff', mar: '#00b9af', sol: '#ffd23f', x: 262, y: 64 },
    { p: 0.75, topo: '#7cc7e8', base: '#ffe9c9', mar: '#12a8a3', sol: '#ffc04d', x: 322, y: 120 },
    { p: 1, topo: '#ff7a59', base: '#ffd0a1', mar: '#2a8f96', sol: '#ff8a3d', x: 360, y: 226 },
  ];
  function hexRgb(h) { var n = parseInt(h.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function rgbHex(c) { return '#' + c.map(function (v) { return Math.round(v).toString(16).padStart(2, '0'); }).join(''); }
  function misturar(a, b, t) {
    var x = hexRgb(a), y = hexRgb(b);
    return rgbHex(x.map(function (v, i) { return v + (y[i] - v) * t; }));
  }
  function ceuEm(p) {
    p = limitar(+p || 0, 0, 1);
    var i = 0;
    while (i < CEU.length - 2 && p > CEU[i + 1].p) i++;
    var a = CEU[i], b = CEU[i + 1];
    var t = (p - a.p) / (b.p - a.p);
    var r = {};
    Object.keys(a).forEach(function (k) {
      if (k === 'p') return;
      r[k] = typeof a[k] === 'string' ? misturar(a[k], b[k], t) : a[k] + (b[k] - a[k]) * t;
    });
    return r;
  }
  // 0 quando a seção aparece embaixo, 1 quando some em cima (igual ao view() do CSS)
  function progresso(top, altura, vh) { return limitar((vh - top) / (vh + altura), 0, 1); }


  var util = {
    classificarUV: classificarUV, cacheValido: cacheValido, hojeSP: hojeSP, chaveLocal: chaveLocal, escolhaValida: escolhaValida,
    CIDADES: CIDADES, FRASE_FALHA: FRASE_FALHA, ceuEm: ceuEm, progresso: progresso, misturar: misturar, limitar: limitar,
  };
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = util;
    return;
  }
  window.Lululi = window.Lululi || {};
  window.Lululi.experiencias = util;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduz = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function lerLS(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function gravarLS(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  // ================= 1) índice UV =================
  var CHAVE_CIDADE = 'lululi-uv-cidade';
  var CHAVE_CACHE = 'lululi-uv-cache';
  var pedidos = {};
  function buscarUV(lugar) {
    var k = chaveLocal(lugar.lat, lugar.lon);
    var agora = Date.now();
    var cache = lerLS(CHAVE_CACHE) || {};
    if (cacheValido(cache[k], agora)) return Promise.resolve(cache[k].v);
    if (pedidos[k]) return pedidos[k];
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var tempo = setTimeout(function () { if (ctrl) ctrl.abort(); }, 6000);
    var url = 'https://api.open-meteo.com/v1/forecast?latitude=' + (+lugar.lat).toFixed(2) + '&longitude=' + (+lugar.lon).toFixed(2) +
      '&daily=uv_index_max&timezone=America%2FSao_Paulo&forecast_days=1';
    pedidos[k] = fetch(url, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error('uv ' + r.status); return r.json(); })
      .then(function (j) {
        var v = j && j.daily && j.daily.uv_index_max && j.daily.uv_index_max[0];
        if (typeof v !== 'number') throw new Error('uv sem valor');
        var c = lerLS(CHAVE_CACHE) || {};
        Object.keys(c).forEach(function (x) { if (!cacheValido(c[x], agora)) delete c[x]; });
        c[k] = { v: v, t: agora, dia: hojeSP(agora) };
        gravarLS(CHAVE_CACHE, c);
        return v;
      })
      .finally(function () { clearTimeout(tempo); delete pedidos[k]; });
    return pedidos[k];
  }

  var escolhaUV = escolhaValida(lerLS(CHAVE_CIDADE));
  function mostrarUV(box, v) {
    var cl = classificarUV(v);
    box.dataset.nivel = cl ? cl.nivel : '';
    $('[data-lululi-uv-dado]', box).hidden = !cl;
    $('[data-lululi-uv-frase]', box).textContent = cl ? cl.frase : FRASE_FALHA;
    if (!cl) return;
    $('[data-lululi-uv-num]', box).textContent = cl.indice;
    $('[data-lululi-uv-classe]', box).textContent = cl.rotulo;
    $('[data-lululi-uv-cidade]', box).textContent = escolhaUV.nome === MINHA ? 'onde você está' : 'em ' + escolhaUV.nome;
  }
  // pílula do cabeçalho: "UV 9 · Natal"; sem dado, só o sol e a cidade
  function mostrarPilulas(v) {
    var cl = classificarUV(v);
    var lugar = escolhaUV.nome === MINHA ? 'Aqui' : escolhaUV.nome;
    $$('[data-lululi-uv-pilula]').forEach(function (p) {
      var num = $('[data-lululi-uv-pnum]', p);
      p.dataset.nivel = cl ? cl.nivel : '';
      num.hidden = !cl;
      num.textContent = cl ? cl.indice : '';
      $('[data-lululi-uv-plugar]', p).textContent = lugar;
      p.setAttribute('aria-label', cl
        ? 'Índice UV hoje: ' + cl.indice + ', ' + cl.rotulo.toLowerCase() + ', ' + (escolhaUV.nome === MINHA ? 'onde você está' : 'em ' + lugar) + '. Ver detalhes'
        : 'Sol de hoje. Ver detalhes');
    });
  }
  function atualizarUV() {
    var boxes = $$('[data-lululi-uv]');
    if (!boxes.length) return;
    boxes.forEach(function (box) {
      var sel = $('[data-lululi-uv-select]', box);
      if (!sel) return;
      var minha = sel.querySelector('option[value="' + MINHA + '"]');
      if (escolhaUV.nome === MINHA && !minha) {
        minha = document.createElement('option');
        minha.value = minha.textContent = MINHA;
        sel.insertBefore(minha, sel.firstChild);
      }
      sel.value = escolhaUV.nome;
    });
    var lugar = escolhaUV;
    buscarUV(lugar).then(
      function (v) { if (lugar === escolhaUV) { boxes.forEach(function (b) { mostrarUV(b, v); }); mostrarPilulas(v); } },
      function () { if (lugar === escolhaUV) { boxes.forEach(function (b) { mostrarUV(b, null); }); mostrarPilulas(null); } } // sem número, só a frase
    );
  }
  function escolherUV(e) {
    escolhaUV = escolhaValida(e);
    gravarLS(CHAVE_CIDADE, escolhaUV);
    atualizarUV();
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-lululi-uv-select]');
    if (!sel) return;
    if (sel.value === MINHA) return; // já está nela
    escolherUV({ nome: sel.value });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lululi-uv-local]');
    if (!b) return;
    var box = b.closest('[data-lululi-uv]');
    var aviso = $('[data-lululi-uv-aviso]', box);
    if (!navigator.geolocation) { aviso.textContent = 'Este aparelho não informa a localização. Escolha a cidade.'; return; }
    var original = b.textContent;
    b.disabled = true;
    b.textContent = 'Procurando…';
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        b.disabled = false;
        b.textContent = original;
        aviso.textContent = '';
        // ponytail: 2 casas (~1 km) bastam para o UV e não guardam o endereço exato
        escolherUV({ nome: MINHA, lat: +pos.coords.latitude.toFixed(2), lon: +pos.coords.longitude.toFixed(2) });
      },
      function () {
        b.disabled = false;
        b.textContent = original;
        aviso.textContent = 'Não deu para pegar a localização. Escolha a cidade.';
      },
      { timeout: 10000, maximumAge: HORA }
    );
  });

  // ================= 2) dia de praia =================
  function iniciarPraia(sec) {
    var pontos = $$('[data-lululi-ponto]', sec);
    function fechar(exceto) {
      pontos.forEach(function (b) {
        if (b === exceto) return;
        b.setAttribute('aria-expanded', 'false');
        b.parentElement.classList.remove('is-aberto');
      });
    }
    pontos.forEach(function (b) {
      b.addEventListener('click', function () {
        var abrir = b.getAttribute('aria-expanded') !== 'true';
        fechar(b);
        b.setAttribute('aria-expanded', String(abrir));
        b.parentElement.classList.toggle('is-aberto', abrir);
      });
    });
    document.addEventListener('click', function (e) { if (!sec.contains(e.target)) fechar(); });
    sec.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var aberto = pontos.filter(function (b) { return b.getAttribute('aria-expanded') === 'true'; })[0];
      fechar();
      if (aberto) aberto.focus();
    });

    // reserva: só onde o CSS não anima pela rolagem. Movimento reduzido fica no meio-dia parado.
    if (reduz || (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'))) return;
    var agendado = false;
    function pintar() {
      agendado = false;
      var r = sec.getBoundingClientRect();
      var vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var c = ceuEm(progresso(r.top, r.height, vh));
      sec.style.setProperty('--ceu-topo', c.topo);
      sec.style.setProperty('--ceu-base', c.base);
      sec.style.setProperty('--mar', c.mar);
      sec.style.setProperty('--sol', c.sol);
      sec.style.setProperty('--sol-x', c.x.toFixed(1));
      sec.style.setProperty('--sol-y', c.y.toFixed(1));
    }
    function agendar() { if (!agendado) { agendado = true; requestAnimationFrame(pintar); } }
    window.addEventListener('scroll', agendar, { passive: true });
    window.addEventListener('resize', agendar, { passive: true });
    pintar();
  }

  // ---------- início ----------
  function iniciar() {
    atualizarUV();
    $$('[data-lululi-praia]').forEach(iniciarPraia);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  // editor de temas: seção nova ou recarregada
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-lululi-praia]', e.target).forEach(iniciarPraia);
    atualizarUV();
  });
})();
